module.exports = __webpack_public_path__ + "img/no-courses.d7739d8c.png";